import React from 'react';
import TextField from '@mui/material/TextField';
import { StyledHelperText } from '#component/project/form/project/styles';

export default props => {
  const {
    classes,
    label,
    info,
    forceError,
    meta = {},
    ...rest
  } = props;

  const input = props.input || {
    value: props.value,
    onChange: props.onChange,
    onBlur: props.onBlur,
    name: props.name
  };

  const isTouched = meta.touched ?? meta.isTouched;
  const isInvalid = meta.invalid ?? !!meta.error;
  const rawError = meta.error;
  const errorMessage = typeof rawError === 'object' ? rawError?.message : rawError;
  const showError = Boolean((isTouched || forceError) && isInvalid);

  return (
    <>
      <TextField
        label={label}
        placeholder={label}
        multiline
        {...input}
        {...rest}
        className={`${rest.className ?? ''} ${showError ? 'invalid' : ''}`}
      />
      {showError && errorMessage && (
        <StyledHelperText error>
          {errorMessage}
        </StyledHelperText>
      )}
    </>
  );
};
